module.exports = __webpack_public_path__ + "static/img/Principal.2b3931b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Principal.png
// module id = 503
// module chunks = 1